class StorageWrapper {
    constructor(storage = localStorage) {
        this.storage = storage;
    }

    get(key) {
        return this.storage.getItem(key);
    }

    getAndRemove(key) {
        const value = this.get(key);
        if (value) {
            this.remove(key);
        }
        return value;
    }

    getJsonAndRemove(key) {
        const jsonValue = this.getAndRemove(key);

        if (!jsonValue) { return null; }

        try {
            return JSON.parse(jsonValue);
        } catch (error) {
            return null;
        }
    }

    set(key, value) {
        this.storage.setItem(key, value);
    }

    setJson(key, value) {
        try {
            const jsonValue = JSON.stringify(value);
            this.set(key, jsonValue);
        } catch (error) {
            //
        }
    }

    remove(key) {
        this.storage.removeItem(key);
    }

    clear() {
        this.storage.clear();
    }
}

module.exports = StorageWrapper;

if (!('olyLocalStorage' in window)) {
    window.olyLocalStorage = new StorageWrapper();
}



// WEBPACK FOOTER //
// ./src/olycommon/localStorageWrapper/storage-wrapper.js